var pageId = '';

pageId = document.querySelector('body').getAttribute('id');
switch (pageId) {
  //body id='top'
  case 'top':
    require('./top.ts');
    break;

  case 'location':
    require('./location.ts');
    break;

  //body id='map'
  case 'outline':
    window.addEventListener('DOMContentLoaded', function () {
      const todayElm = document.querySelectorAll('.js-todayElm');
      const nextElm = document.querySelectorAll('.js-nextElm');
      const upToday = new Date();
      const upNext = new Date();
      upNext.setDate(upToday.getDate() + 14)

      const todayM = upToday.getMonth() + 1;
      const nextM = upNext.getMonth() + 1;
      for (let i = 0; i < todayElm.length; i++) {
        todayElm[i].innerHTML = upToday.getFullYear() + "年" + todayM + "月" + upToday.getDate() + "日";
      }
      for (let i = 0; i < nextElm.length; i++) {
        nextElm[i].innerHTML = upNext.getFullYear() + "年" + nextM + "月" + upNext.getDate() + "日";
      }
    });
    break;
};

//common
require('./anime.ts');

// ページトップ共通
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelector('.fv').classList.add('is-loaded');
// });

// const header = document.querySelector('header');

// let lastScrollY = window.scrollY;
// let accumulatedScroll = 0;
// const threshold = window.innerHeight * 1; // 10vh

// window.addEventListener('scroll', function () {
//   const currentScrollY = window.scrollY;
//   const diff = currentScrollY - lastScrollY;

//   // 下スクロール
//   if (diff > 0) {
//     accumulatedScroll += diff;
//     header.classList.add('hScroll'); // 非表示
//   }
//   // 上スクロール
//   else {
//     accumulatedScroll += diff;

//     if (Math.abs(accumulatedScroll) > threshold) {
//       header.classList.remove('hScroll'); // 表示
//       accumulatedScroll = 0;
//     }
//   }

//   // リセット（方向が変わったら）
//   if ((diff > 0 && accumulatedScroll < 0) || (diff < 0 && accumulatedScroll > 0)) {
//     accumulatedScroll = 0;
//   }

//   lastScrollY = currentScrollY;
// });

// ヘッダー関連(ロゴ、グロナビ)
document.addEventListener('DOMContentLoaded', () => {
  const html = document.documentElement;
  const body = document.body;
  const header = document.querySelector('.header');
  const fv = document.querySelector('.fv');
  const navButton = document.querySelector('#js-globalNaviButton');
  const gNavi = document.querySelector('#js-globalNavi');
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

  if (fv) {
    fv.classList.add('is-loaded');
  }

  if (navButton && gNavi) {
    navButton.addEventListener('click', () => {
      const isActive = gNavi.classList.contains('is-active');

      body.classList.toggle('is-open');
      body.classList.toggle('noScroll');

      if (isActive) {
        gNavi.classList.remove('is-active');
        navButton.classList.remove('active');

        setTimeout(() => {
          html.style.scrollbarGutter = 'revert';
          gNavi.style.display = 'none';
        }, 400);
      } else {
        html.style.scrollbarGutter = 'stable';
        gNavi.style.display = 'block';
        navButton.classList.add('active');

        setTimeout(() => {
          gNavi.classList.add('is-active');
        }, 100);
      }
    });
  }

  let lastScrollY = window.scrollY;
  let showTimer = null;

  const handleHeaderScroll = () => {
    if (body.classList.contains('is-open')) return;

    const currentY = window.scrollY;
    const diff = currentY - lastScrollY;

    if (diff === 0) return;

    // 下スクロール
    if (diff > 0) {
      header.classList.add('is-hidden');

      // 上スクロール用のタイマーをキャンセル
      if (showTimer) {
        clearTimeout(showTimer);
        showTimer = null;
      }
    }

    // 上スクロール
    if (diff < 0) {
      // すでにタイマーがあれば何もしない（二重防止）
      if (!showTimer) {
        showTimer = setTimeout(() => {
          header.classList.remove('is-hidden');
          showTimer = null;
        }, 1000); // ←ここが2秒
      }
    }

    lastScrollY = currentY;
  };

  window.addEventListener('scroll', handleHeaderScroll);


  smoothScrollTrigger.forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');

      if (!href || href === '#') return;

      const targetElement = document.getElementById(href.replace('#', ''));
      if (!targetElement) return;

      event.preventDefault();

      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.scrollY;
      const gap = 0;
      const target = rect + offset - gap;

      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  });
});

// ______________________________________

// 下固定エントリーボタン
let lastScrollTop = 0;
let scrollUpDistance = 0;
let scrollDownDistance = 0;

const btn = document.querySelector('.bottom_btn');

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const threshold = window.innerHeight * 0.3; // 10vh

  if (scrollTop < lastScrollTop) {
    // 上スクロール
    scrollUpDistance += lastScrollTop - scrollTop;
    scrollDownDistance = 0;

    if (scrollUpDistance > threshold) {
      btn.classList.add('is-show');
    }
  } else if (scrollTop > lastScrollTop) {
    // 下スクロール
    scrollDownDistance += scrollTop - lastScrollTop;
    scrollUpDistance = 0;

    if (scrollDownDistance > threshold) {
      btn.classList.remove('is-show');
    }
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});
// ______________________________________